<div class="plan-payment-container" [@fadeIn]>
  <!-- Loading Progress Bar (Requirement 15.3) -->
  <mat-progress-bar 
    *ngIf="isLoading" 
    mode="indeterminate" 
    color="primary"
    class="loading-bar">
  </mat-progress-bar>

  <!-- Dashboard Summary Cards -->
  <!-- Requirements: 1.1, 1.2, 6.1, 6.2, 6.3, 6.4, 6.5, 11.1 -->
  <app-summary-cards [summary]="dashboardSummary"></app-summary-cards>

  <!-- Tabs Navigation -->
  <!-- Requirements: 2.1, 2.2, 2.4, 2.5, 11.2 -->
  <mat-tab-group 
    [(selectedIndex)]="selectedTabIndex" 
    (selectedIndexChange)="onTabChange($event)"
    animationDuration="250ms"
    class="plan-payment-tabs">
    
    <!-- ABA 1: Meus Planos (Titular) -->
    <mat-tab label="Meus Planos">
      <ng-template matTabContent>
        <div class="tab-content" [@slideInOut]>
          <app-user-plans 
            [plans]="plans"
            [isLoading]="isLoading"
            (planSelected)="onPlanSelected($event)">
          </app-user-plans>
        </div>
      </ng-template>
    </mat-tab>
    
    <!-- ABA 2: Meus Pagamentos (Titular) -->
    <mat-tab label="Meus Pagamentos">
      <ng-template matTabContent>
        <div class="tab-content" [@slideInOut]>
          <app-user-payments 
            [payments]="payments"
            [filterByPlanId]="selectedPlanId"
            [isLoading]="isLoading"
            (paymentSelected)="onPaymentSelected($event)">
          </app-user-payments>
        </div>
      </ng-template>
    </mat-tab>

    <!-- ABA 3: Aguardando Aceitação (Titular) -->
    <mat-tab *ngIf="hasTitularPendingPlans">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">hourglass_top</mat-icon>
        Aguardando Aceitação
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content" [@slideInOut]>
          <app-titular-pending-plans [cpfcnpj]="user?.cpf ?? ''"></app-titular-pending-plans>
        </div>
      </ng-template>
    </mat-tab>

    <!-- ABA 4: Planos Pendentes (Pagador Externo) -->
    <mat-tab *ngIf="hasPendingPayerPlans">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">pending_actions</mat-icon>
        Pendentes (Pagador)
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content" [@slideInOut]>
          <app-payer-pending-plans [userCpf]="userCpf"></app-payer-pending-plans>
        </div>
      </ng-template>
    </mat-tab>

    <!-- ABA 5: Meus Planos como Pagador -->
    <mat-tab *ngIf="hasAcceptedPayerPlans">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">credit_card</mat-icon>
        Sou Pagador
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content" [@slideInOut]>
          <app-payer-plans [userCpf]="userCpf"></app-payer-plans>
        </div>
      </ng-template>
    </mat-tab>

    <!-- ABA 6: Minhas Parcelas como Pagador -->
    <mat-tab *ngIf="hasAcceptedPayerPlans">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">receipt_long</mat-icon>
        Minhas Parcelas
      </ng-template>
      <ng-template matTabContent>
        <div class="tab-content" [@slideInOut]>
          <app-payer-installments [userCpf]="userCpf"></app-payer-installments>
        </div>
      </ng-template>
    </mat-tab>

  </mat-tab-group>
</div>
